export const INITIAL_STATE = {
  appVersion: '',
  downloadLink: '',
};
